import { render, staticRenderFns } from "./DetailAmounts.vue?vue&type=template&id=2598de63&scoped=true"
import script from "./DetailAmounts.vue?vue&type=script&lang=ts"
export * from "./DetailAmounts.vue?vue&type=script&lang=ts"
import style0 from "./DetailAmounts.vue?vue&type=style&index=0&id=2598de63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598de63",
  null
  
)

export default component.exports